// extracted by mini-css-extract-plugin
export default {"resBx":"barchart_resBx__cucPk"};